// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__sV-Nq","approved":"Status_approved__24zlY","rejected":"Status_rejected__2waqE","expired":"Status_expired__2PHzD","label":"Status_label__-qmne"};